import MyApp from '@/components/MyApp';
import routes from '@/lib/routes';
import Dashboard from '@/components/Dashboard';
import app from '@/lib/app';

export function appHotelmeister() {
  app('MyApp', MyApp, {}, routes);
}

export default appHotelmeister;



// WEBPACK FOOTER //
// ./src/pages/index.js